export default __webpack_public_path__ + "static/media/person_3.625748c8.png";